// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__U-16J","error":"InputSecondary_error__1ss2A","disabled":"InputSecondary_disabled__2TIE9"};